import request from '@/utils/request.ts'

//获取数据表
export const gettableinfo = (params: any) =>
  request({
    url: '/topicladder/getTopicData',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
//更新数据表
export const updateinfo = (params: any) =>
  request({
    url: '/topicladder/saveOrUpdateTopicLadderInfo',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })

//更新富文本编辑器内容
export const saveOrupdateContent = (params: any) =>
  request({
    url: '/topicladder/saveOrupdateContent',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
//更新课题成果目录
export const updateTopicResult = (params: any) =>
  request({
    url: '/topicladder/saveOrupdateResult',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })

//更新课题经费使用情况
export const updateTopicFunding = (params: any) =>
  request({
    url: '/topicladder/saveOrupdateFunding',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })

// 上传相关证书接口
export const uploadzsxg = (params: any) =>
  request({
    url: '/topicladdercertificate/uploadFile',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// 更新相关证书内容

export const updateuploadfile = (params: any) =>
  request({
    url: '/topicladdercertificate/updatePic',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// 删除文pic
export const removefile = (params: any) =>
  request({
    url: '/topicladdercertificate/removePic',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// 获取相关证书info
export const getfiles = (params: any) =>
  request({
    url: '/topicladdercertificate/getPicList',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// 获取已上传的课题附件列表
export const getAccessoryList = (params: any) =>
  request({
    url: '/topicladdercertificate/getAccessoryList',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// 删除上传的课题附件列表
export const updatetopicfile = (params: any) =>
  request({
    url: '/topicladdercertificate/updateFile',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })

// 获取生成得申报pdf集合
export const downloadpdf = (params: any) =>
  request({
    url: '/pdfstate/getPdf',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// 修改课题状态
export const updateStatus = (params: any) =>
  request({
    url: '/topic/updateStatus',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// 下载
export const downloadfile = (params: any) =>
  request({
    url: '/accessory/downloadDoc',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })

// 下载已填写的申报内容
export const downloadPDF = () =>
  request({
    url: '/topicdatadetail/exp/outWord/1',
    // method: 'post',
    // data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })